import { Token } from '@ui/config/token';
import type { TokenOnH2 } from '@ui/config/token/types';
import { Fraction } from 'bi-fraction';
import { create } from 'zustand';

interface H2SwapFormStore {
  enteredAmountStr: string;
  enteredAmount: Fraction;
  mode: 'buy-agent' | 'sell-agent';
  fromToken: TokenOnH2;
  toToken: Exclude<TokenOnH2, Token.zkCRO>;
  setEnteredAmountStr: (enteredAmountStr: string) => void;
  switchTokenPair: (mode: 'buy-agent' | 'sell-agent') => void;
}

export const useH2SwapForm = create<H2SwapFormStore>((set) => ({
  enteredAmountStr: '',
  mode: 'buy-agent',
  enteredAmount: Fraction.ZERO,
  fromToken: Token.agentFun,
  toToken: Token.Agent,
  setEnteredAmountStr: (enteredAmountStr: string) => {
    set({
      enteredAmountStr,
      enteredAmount: Fraction.tryParse(enteredAmountStr) ?? Fraction.ZERO,
    });
  },
  switchTokenPair: (mode) => {
    set((state) => {
      if (mode === state.mode) return {};
      return {
        mode: state.mode === 'buy-agent' ? 'sell-agent' : 'buy-agent',
        fromToken: state.toToken,
        toToken:
          state.fromToken === Token.zkCRO ? Token.wzkCRO : state.fromToken,
      };
    });
  },
}));
